import { render } from "./Game.vue?vue&type=template&id=29b0f559&bindings={}"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script